"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildParamsWithDefaults = exports.parseCustomParams = void 0;
const filterDefined_1 = require("../filterDefined");
const defaults_1 = require("./defaults");
const parseCustomParams = (paramsOrCustomErrorMessage) => (0, filterDefined_1.filterDefined)(typeof paramsOrCustomErrorMessage === 'string'
    ? { errorMessage: paramsOrCustomErrorMessage }
    : paramsOrCustomErrorMessage || {});
exports.parseCustomParams = parseCustomParams;
const buildParamsWithDefaults = (paramsOrCustomErrorMessage) => (Object.assign(Object.assign({}, defaults_1.defaultParams), (0, exports.parseCustomParams)(paramsOrCustomErrorMessage)));
exports.buildParamsWithDefaults = buildParamsWithDefaults;
//# sourceMappingURL=utils.js.map